
import React from 'react';
import { Link } from 'react-router-dom';

const Introduction: React.FC = () => {
  return (
    <>
      <p className="text-lg font-medium text-gray-700 mb-6 leading-relaxed">
        The cybersecurity landscape has transformed dramatically in recent years, with threats becoming increasingly sophisticated. 
        For small businesses, this evolution presents a significant challenge – research shows that approximately 60% of small companies 
        that suffer a major data breach shut down within six months. This alarming statistic highlights why implementing a 
        <Link to="/services/cybersecurity" className="text-itmgmt-bright-blue hover:underline"> zero-trust security framework</Link> has become essential for business continuity in today's digital environment.
      </p>

      <h2 className="text-2xl font-bold mb-4 mt-8 text-itmgmt-dark-blue">Understanding Zero-Trust Security: Beyond the Perimeter</h2>
      
      <div className="bg-itmgmt-light-blue/20 p-6 rounded-lg mb-6 border-l-4 border-itmgmt-medium-blue">
        <p className="text-gray-800 italic mb-0">
          "Zero-trust operates on one fundamental premise: trust nothing, verify everything. Unlike traditional security that focuses on 
          defending boundaries, zero-trust acknowledges that threats can originate from anywhere – inside or outside your organization."
        </p>
      </div>
      
      <p className="mb-5 text-gray-700 leading-relaxed">
        In practical terms, this security philosophy translates to:
      </p>
    </>
  );
};

export default Introduction;
